import React, { PropsWithChildren } from 'react';
import { DossierValidatorsProvider } from './DossierValidatorsProvider';
import { FormalitiesProvider } from './FormalitiesProvider';
import { FormulairesProvider } from './FormulairesProvider';

export type DossiersDataProviderProps = {
    formalities?: boolean;
    forms?: boolean;
    validators?: boolean;
};

export const DossiersDataProvider: React.FunctionComponent<
    PropsWithChildren<DossiersDataProviderProps>
> = function ({ formalities = true, forms = true, validators = true, children }) {
    return (
        <DossierValidatorsProvider autoload={formalities}>
            <FormalitiesProvider autoload={forms}>
                <FormulairesProvider autoload={validators}>{children}</FormulairesProvider>
            </FormalitiesProvider>
        </DossierValidatorsProvider>
    );
};
